export default {
  props: {
    placement: {
      default: "top",
      type: String
    },
    content: {
      default: "",
      type: String
    },
    effect: {
      default: "dark",
      type: String
    }
  }
};